import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
export class TimedRenderer extends React.Component {
    _timer;
    constructor(props) {
        super(props);
    }
    _recreateTimer({ active, interval }) {
        if (this._timer != null) {
            clearInterval(this._timer);
        }
        this._timer = null;
        if (active) {
            this._timer = setInterval(this.forceUpdate.bind(this), interval);
        }
    }
    _propsChanged(prev, next) {
        return prev.active !== next.active || prev.interval !== next.interval;
    }
    componentDidMount() {
        this._recreateTimer(this.props);
    }
    componentWillUnmount() {
        this._recreateTimer({ active: false, interval: 0, children: () => _jsx(_Fragment, {}) });
    }
    componentDidUpdate(prevProps) {
        if (this._propsChanged(prevProps, this.props)) {
            this._recreateTimer(this.props);
        }
    }
    render() {
        return this.props.children();
    }
}
